import { AddressSearchResult } from '@bhtp-client-api/eligibility';

export class AddressResult extends AddressSearchResult {
    public errorMessage: string = null;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/address-result.model.ts